// Generated by purs version 0.15.15
import * as Data_Enum from "../Data.Enum/index.js";
var toCharCode = /* #__PURE__ */ Data_Enum.fromEnum(Data_Enum.boundedEnumChar);
var fromCharCode = /* #__PURE__ */ Data_Enum.toEnum(Data_Enum.boundedEnumChar);
export {
    toCharCode,
    fromCharCode
};
